// Create Valera
// Please ask me for any changes
var Config = {
	Host: window.location.hostname
}
switch (Config.Host) {
	case 'fertimo.loc' : // this is local 
			Config = {
				AppId		: '9ccbd76a8cf2ac1558cd98a62c710e3a77192765',
				// ApiURL		: 'http://service.gymstinct.loc/?ApiID=9ccbd76a8cf2ac1558cd98a62c710e3a77192765',
				ApiURL		: 'https://service.gymstinct.com/',
				BaseUrl 	: 'http://fertimo.loc:5000/#/',
				// StaticURL 	: 'https://static.gymstinct.com/',
				// ImgPath 	: {
				// 	0 	: 'https://static.gymstinct.com/imgpath/no-photo/no-photo.jpg',
				// 	1 	: 'https://static.gymstinct.com/imgpath/origin/',
				// 	100 : 'https://static.gymstinct.com/imgpath/100/',
				// 	500 : 'https://static.gymstinct.com/imgpath/500/',
				// }
			}
		break;
	default: // this is production
			Config = {
				AppId		: '9ccbd76a8cf2ac1558cd98a62c710e3a77192765',
				ApiURL		: 'https://service.gymstinct.com/',
				BaseUrl 	: 'https://www.fertimo.com/#/',
				// StaticURL 	: 'https://static.gymstinct.com/',
				// ImgPath 	: {
				// 	0 	: 'https://static.gymstinct.com/imgpath/no-photo/no-photo.jpg',
				// 	1 	: 'https://static.gymstinct.com/imgpath/origin/',
				// 	100 : 'https://static.gymstinct.com/imgpath/100/',
				// 	500 : 'https://static.gymstinct.com/imgpath/500/',
				// }
			}
		break;
}

// Global variable's in in config
Config.ProjectID	= 2;
Config.ProjectTitle = 'Fertimo business';
Config.Project 		= 'business.fertimo.com';
Config.CopyText		= '© 2019';

// Data table page length
Config.SoftVersion = 1;

// Export config
export const Conf = Config;



// WEBPACK FOOTER //
// ./src/Config.js